import { useState } from 'react'

export const useRangeInput = ({ fromInit, toInit, errors = [] }) => {
    const [from, setFrom] = useState(fromInit)
    const [to, setTo] = useState(toInit)
    const [error, setError] = useState('')

    const handleRange = (field, value, currentState) => {
        if (field === 'from'){
            setFrom(value)
            currentState({from: value, to})
        } else if (field === 'to'){
            setTo(value)
            currentState({to: value, from})
        }
    }

    const handleError = err => {
        if (!err) setError('')
        if (err && !errors.length) {
            setError(err)
        } else if (err !== null && err !== undefined && errors.length) {
            setError(errors[err])
        }
    }

    return { from, to, handleRange, error, handleError }
}
